import http from 'core/http-common'
import {
  IFilteredDoctorList,
  IDoctorTitleList,
  IDoctorSpecialtyList,
  IHealthLocationList,
  IDoctorFilterForm,
  ISaveDoctorAppointment,
  IGetDoctorTimeTableQueries,
  IGetDoctorTimeTableList,
} from 'types/HealthType'

class HealthService {
  getHealtServiceDetailByDoctorId(doctorId: string | number) {
    return http.get(`Health/GetHealthServiceByHealthServiceDoctorId?healthServiceDoctorId=${doctorId}`)
  }

  getLocations() {
    return http.get<IHealthLocationList[]>(`Health/GetLocationList`)
  }

  getLocationsByReferanceDate(referanceDate: string | Date) {
    return http.get<IHealthLocationList[]>(`Health/GetLocationListByReferanceDate?referanceDate=${referanceDate}`)
  }

  getTitles() {
    return http.get<IDoctorTitleList[]>(`Health/GetTitleList`)
  }

  getSpecialties() {
    return http.get<IDoctorSpecialtyList[]>(`Health/GetSpecialtyList`)
  }

  getSpecialtiesByLocationId(locationId: string | number) {
    return http.get<IDoctorSpecialtyList[]>(`Health/GetSpecialtyListByLocationId?locationId=${locationId}`)
  }

  getSpecialtiesByLocationIds(data: { LocationIds: number[] }) {
    return http.post<IDoctorSpecialtyList[]>(`Health/GetSpecialtyListByLocationIds`, data)
  }

  /* Doctor related services */
  getDoctorFilteredList(data: IDoctorFilterForm) {
    return http.post<IFilteredDoctorList[]>(`Doctor/GetDoctorFilteredList`, data)
  }

  getDoctor(healthServiceDoctorId: string | number) {
    return http.get(`Doctor/GetHealthServiceDoctor?healthServiceDoctorId=${healthServiceDoctorId}`)
  }

  getDoctorPhoto(doctorId: string | number) {
    return http.get(`Doctor/GetDoctorPhotoBase64String?doctorId=${doctorId}`)
  }

  getDoctorAppointmentTableList(data: IGetDoctorTimeTableQueries) {
    return http.post<IGetDoctorTimeTableList[]>(`DoctorReservation/GetDoctorTimeTableList`, data)
  }

  saveDoctorAppointment(data: ISaveDoctorAppointment) {
    return http.post(`DoctorReservation/SaveDoctorReservation`, data)
  }

  /* Favorite */
  addDoctorFavorite(doctorId: number) {
    return http.get(`FavoriteHealthServiceDoctor/Save?healthServiceDoctorId=${doctorId}`)
  }
  removeDoctorFavorite(doctorId: number) {
    return http.get(`FavoriteHealthServiceDoctor/Delete?healthServiceDoctorId=${doctorId}`)
  }
}

export default new HealthService()
